var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm._f("insertComma")(_vm.price)))]),_vm._v(_vm._s(_vm.unit())+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }